import { StudyFile } from "../Study/study-file.model";

export class Status {
  id: number;
  name: number;
  altName: number;
}

export class StudyStatus {
  statusId: number;
  statusName: string;
  studyId: number;
  message: string;
}

export class UpdateStatusResponse {
  studyId: number;
  statusId: number;
  statusName: string;
}

export class UpdateStatusFileResponse {
  studyFileIds: number[];
  studyFiles: StudyFile[];
  statusId: number;
  statusName: string;
  statusMessage: string;
  submissionNotification: any;
  isLotHasXrayImagesSubmittedAcknowledged: boolean;
  isLotHasScopeVideoSubmittedAcknowledged: boolean;
  isStudyUploadedToDifferentLotAcknowledged: boolean;
}

export class UpdateStudyAndStudyFileStatusResponse {
  studyId: number;
  statusId: number;
  statusName: string;
  studyFileIds: number[];
  studyFileStatusMessage: string;
}
